import { TApplicationState } from 'shared/types/redux';

export function getGaGeoLabel(state: TApplicationState): string {
  const {
    newbuilding: { gaLabel },
  } = state;

  return gaLabel;
}
